import { render, staticRenderFns } from "./radio-list.vue?vue&type=template&id=c7effd88&"
import script from "./radio-list.vue?vue&type=script&lang=js&"
export * from "./radio-list.vue?vue&type=script&lang=js&"
import style0 from "./_radio-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports